cockpitApp.controller('sidenavController', [
  '$rootScope', '$scope', 'basketHelper',
  function($rootScope, $scope, basketHelper)
  {
    $scope.getNumberOfElementsInBasket = function() {
      return basketHelper.getNumberOfElementsInBasket();
    };
  }
]);
